import React, { Component } from 'react'
import { connect } from 'react-redux'
import Header from '../../components/Header/header'
import Sidebar from '../../components/Sidebar/Sidebar'
import { Grid, Content } from '../../components/Layout'
import * as API from '../../api'
import { ReloadButton } from '../../components/Form'
import { SimpleLoader, WrapperLoader } from '../../components/loaders'
import Message from '../../components/PageMessage'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''

// Página aberta pelo QR Code da FDS de um produto: consulta a API pelo token e segue
// para o PDF. O destino é a rota da API, que gera a URL assinada a cada acesso, e não
// a URL assinada em si: recarregar a aba do PDF depois de minutos continua abrindo.
export class ProductFds extends Component {
  static defaultProps = {
    getProductFds: token => API.productFds.getProductFds(token),
    redirect: url => window.location.replace(url)
  }

  state = {
    status: 'loading' // 'loading' | 'invalid' | 'failed' | 'empty'
  }

  componentDidMount() {
    this.fetch()
  }

  fetch = () => {
    const { getProductFds, redirect, router } = this.props

    this.setState({ status: 'loading' })

    return getProductFds(router.match.params.token)
      .then(({ data = {} }) => {
        // com o PDF, a página continua no loader até o navegador trocar para ele
        if (data.document_url) return redirect(`${API_BASE_URL}${data.document_url}`)

        this.setState({ status: 'empty', name: data.name })
      })
      .catch(err => {
        const notFound = err && err.response && err.response.status === 404

        this.setState({ status: notFound ? 'invalid' : 'failed' })
      })
  }

  renderContent() {
    const { status, name } = this.state

    switch (status) {
      case 'invalid':
        return (
          <Message>
            <strong>QR Code inválido ou expirado.</strong>
            <span>Solicite ao responsável um novo QR Code da FDS deste produto.</span>
          </Message>
        )

      case 'failed':
        return (
          <Message>
            <strong>Falha ao abrir a FDS deste produto.</strong>

            <ReloadButton onClick={this.fetch} />
          </Message>
        )

      case 'empty':
        return (
          <Message>
            <strong>Este produto está sem FDS anexada no momento.</strong>
            {name && <span>{name}</span>}
          </Message>
        )

      default:
        return (
          <WrapperLoader>
            <SimpleLoader />
          </WrapperLoader>
        )
    }
  }

  render() {
    const { menuItems = [], router, accessToken } = this.props

    return (
      <Grid>
        <Header router={router} />
        {accessToken && <Sidebar menuItems={menuItems} router={router} />}
        <Content>{this.renderContent()}</Content>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  accessToken: state.headers.accessToken
})

export default connect(mapStateToProps)(ProductFds)



// WEBPACK FOOTER //
// ./src/containers/ProductFds/ProductFds.js